import { api } from "../components/utils/JWTAuth";
import React, { Component } from "react";
import { Row, Col, Container } from "react-grid-system";
import { Link } from "react-router-dom";
import CategoriesMultimedia from "../components/WidgetsSidebar/categoriesMultimedia";
import Newsletter from "../components/WidgetsSidebar/newsletter";
import ImageDefault from "../components/img/noticias_default.jpg";
import TopImageTitle from "../components/objects/topImageTitle";
import ModalVideo from "react-modal-video";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Icons from "@fortawesome/free-solid-svg-icons";
import ReactGA from "react-ga";
import Cookies from "js-cookie";
import SEO from "../components/objects/seo";

import {
	FacebookIcon,
	FacebookShareButton,
	TwitterIcon,
	TwitterShareButton,
} from "react-share";
class MultimediaNotice extends Component {
	constructor(props) {
		super(props);
		this.state = {
			posts: [],
			prevPost: [],
			nxtPost: [],
			isOpen: false,
			postID: "",
		};
		this.openModal = this.openModal.bind(this);
	}
	componentDidMount() {
		window.scrollTo(0, 0);
		//var url = window.location.href.split("/");
		//var pathurl = "/" + url[4] + "/" + url[5] + "/" + url[6] + "/";
		const permalink = this.props.match.params.permalink;
		const cat = this.props.match.params.cat;
		const id = this.props.match.params.id;
		//fetch(`noticia/${permalink}`);

		let formData = new FormData();

		if (!id) {
			formData.append("permalink", "/" + permalink);
		} else {
			formData.append(
				"permalink",
				"/" + permalink + "/" + cat + "/" + id + "/"
			);
		}

		//formData.append("permalink", pathurl);

		//Call to webservice to get the new
		api.post("/multimedia_get_by_permalink", formData).then((res) => {
			//console.log(res);
			this.setState({
				posts: res.data.records,
				postID: res.data.records[0].id,
			});

			var prevId = res.data.records[0].id - 1;
			var nextId = +res.data.records[0].id + 1;

			var formDataprev = new FormData();
			formDataprev.append("id", prevId);
			api.post("/multimedia_get_by_id", formDataprev).then((res) => {
				this.setState({
					prevPost: res.data.records,
				});
			});

			var formDatanext = new FormData();
			formDatanext.append("id", nextId);
			api.post("/multimedia_get_by_id", formDatanext).then((res) => {
				this.setState({
					nxtPost: res.data.records,
				});
			});
		});
		ReactGA.pageview(window.location.pathname + window.location.search);
	}
	componentDidUpdate(prevProps, prevState, snapshot) {
		window.scrollTo(0, 0);
		//var url = window.location.href.split("/");
		//var pathurl = "/" + url[4] + "/" + url[5] + "/" + url[6] + "/";
		const permalink = this.props.match.params.permalink;
		const cat = this.props.match.params.cat;
		const id = this.props.match.params.id;

		//fetch(`noticia/${permalink}`);
		if (this.props.match.params !== prevProps.match.params) {
			let formData = new FormData();
			if (!id) {
				formData.append("permalink", "/" + permalink);
			} else {
				formData.append(
					"permalink",
					"/" + permalink + "/" + cat + "/" + id + "/"
				);
			}
			//formData.append("permalink", pathurl);

			//Call to webservice to get the new
			api.post("/multimedia_get_by_permalink", formData).then((res) => {
				//console.log(res);
				this.setState({
					posts: res.data.records,
					postID: res.data.records[0].id,
				});
				var prevId = res.data.records[0].id - 1;
				var nextId = +res.data.records[0].id + 1;
				let formData = new FormData();
				formData.append("id", prevId);
				api.post("/multimedia_get_by_id", formData).then((res) => {
					this.setState({
						prevPost: res.data.records,
					});
				});

				var formDatanext = new FormData();
				formDatanext.append("id", nextId);
				api.post("/multimedia_get_by_id", formDatanext).then((res) => {
					this.setState({
						nxtPost: res.data.records,
					});
				});
			});
		}
	}
	componentWillReceiveProps(nextProps) {
		const permalink = this.props.match.params.permalink;
		const cat = this.props.match.params.cat;
		const id = this.props.match.params.id;
		if (nextProps.match.params !== this.props.match.params) {
			window.scrollTo(0, 0);
			let formData = new FormData();
			if (!id) {
				formData.append("permalink", permalink);
			} else {
				formData.append(
					"permalink",
					"/" + permalink + "/" + cat + "/" + id + "/"
				);
			}
			//formData.append("permalink", pathurl);

			//Call to webservice to get the new
			api.post("/multimedia_get_by_permalink", formData).then((res) => {
				//console.log(res);
				this.setState({
					posts: res.data.records,
				});
				var prevId = res.data.records[0].id - 1;
				var nextId = +res.data.records[0].id + 1;
				let formData = new FormData();
				formData.append("id", prevId);
				api.post("/multimedia_get_by_id", formData).then((res) => {
					this.setState({
						prevPost: res.data.records,
					});
				});

				var formDatanext = new FormData();
				formDatanext.append("id", nextId);
				api.post("/multimedia_get_by_id", formDatanext).then((res) => {
					this.setState({
						nxtPost: res.data.records,
					});
				});
			});
		}
	}
	openModal() {
		this.setState({ isOpen: true });
	}

	render() {
		const { posts } = this.state;
		const { prevPost } = this.state;
		const { nxtPost } = this.state;
		let editThisPage;
		if (Cookies.get("isAdmin") === "1") {
			editThisPage = (
				<div>
					<a
						className="button textWhite editEntryButton"
						target="_blank"
						rel="noopener noreferrer"
						href={
							global.urlAdmin + "dashboard/multimedia/edit/" + this.state.postID
						}
					>
						Editar entrada
					</a>
				</div>
			);
		} else {
			editThisPage = "";
		}
		const title = posts.map((post, index) => {
			return (
				<TopImageTitle
					key={post.id}
					key_id={post.id + index}
					title={post.title}
					cover_image={post.cover_image}
					bread01={post.categories.map((categories) => categories.name)}
				></TopImageTitle>
			);
		});

		const video = posts.map((post, index) => {
			if (!post.video_url || post.video_url === "undefined") {
				return null;
			} else {
				return (
					<span key={index}>
						<ModalVideo
							channel="youtube"
							isOpen={this.state.isOpen}
							videoId={post.video_url}
							onClose={() => this.setState({ isOpen: false })}
						/>
						<button className="button" onClick={this.openModal}>
							Ver video
						</button>
					</span>
				);
			}
		});

		const previousPost = prevPost.map((post) => {
			return (
				<Col sm={5} key={post.id}>
					<Link to={`/multimedia${post.permalink}`} className="post-prev">
						<p className="m-2 m-lg-0">Anterior Noticia</p>
						<h6 className="text-truncate d-none d-lg-block">{post.title}</h6>
					</Link>
				</Col>
			);
		});
		const notMorePrevPost = (
			<Col sm={5}>
				<Link to="#" className="post-prev">
					<p className="m-2 m-lg-0">No hay más noticias</p>
				</Link>
			</Col>
		);
		const notMorenextPost = (
			<Col sm={5}>
				<Link to="#" className="post-next">
					<p className="m-2 m-lg-0">No hay más noticias</p>
				</Link>
			</Col>
		);
		const nextPost = nxtPost.map((post) => {
			return (
				<Col sm={5} key={post.id}>
					<Link to={`/multimedia${post.permalink}`} className="post-next">
						<p className="m-2 m-lg-0">Siguiente Noticia</p>
						<h6 className="text-truncate d-none d-lg-block">{post.title}</h6>
					</Link>
				</Col>
			);
		});
		const defaultImage = posts.map((post) => {
			if (!post.cover_image) {
				return (
					<img
						key={post.id}
						src={ImageDefault}
						alt="Multimedia"
						className="blogImage"
					></img>
				);
			} else {
				return (
					<img
						key={post.id}
						src={post.cover_image}
						alt="Multimedia"
						className="blogImage"
					></img>
				);
			}
		});
		const socialShare = posts.map((post, index) => {
			var image = post.cover_image
				? post.cover_image
				: "https://fes-sociologia.com/images/fes_logo.jpg";

			return (
				<div key={index}>
					<FacebookShareButton
						url={
							global.socialShare +
							"?link=/multimedia" +
							post.permalink +
							"&image=" +
							image +
							"&title=" +
							encodeURIComponent(post.title.trim()) +
							"&description=" +
							encodeURIComponent(post.meta_description.trim()) +
							"&type=3"
						}
						quote="Federacion Española de Sociología "
					>
						<FacebookIcon size={32} round={true} />
					</FacebookShareButton>
					<TwitterShareButton
						title={post.title}
						url={window.location.href}
					>
						<TwitterIcon size={32} round={true} />
					</TwitterShareButton>
				</div>
			);
		});
		const catNotWant = global.notWantedCategoriesMulti;
		let categoriesTopLeft;
		if (posts[0]) {
			categoriesTopLeft = posts[0].categories.map((categories, index) => {
				if (!categories.length) {
					return null;
				} else {
					if (catNotWant.some((r) => categories.id.includes(r))) {
						return null;
					} else {
						return (
							<Link
								className="button"
								key={categories.id + index}
								to={"/categoria/" + categories.id}
							>
								<span>{categories.name}</span>
							</Link>
						);
					}
				}
			});
		}
		const notice = posts.map((post) => {
			var date = post.published_date;
			date = date.split(" ")[0];
			var yyyy = date.split("-")[0];
			var mmmm = date.split("-")[1];
			var dddd = date.split("-")[2];
			date = dddd + "-" + mmmm + "-" + yyyy;
			return (
				<Col key={post.id}>
					<div className="inner">
						{defaultImage}
						<span className="categoryNewsTop">{categoriesTopLeft}</span>
						<div className="noticeInfo">
							<div>
								<p>{date}</p>
							</div>
							<div className="socialShare">{socialShare}</div>
						</div>
						<h2>{post.title}</h2>

						<div dangerouslySetInnerHTML={{ __html: post.content }} />
					</div>{" "}
					<div className="videoContent">{video}</div>
					<hr className="separatorNew"></hr>
					<Container>
						<Row className="postNavigation">
							{!prevPost.length ? notMorePrevPost : previousPost}
							<Col sm={2}>
								<Link to="/informate/multimedia">
									<i className="fa fa-th allPost"></i>{" "}
								</Link>
							</Col>
							{!nxtPost.length > 0 ? notMorenextPost : nextPost}
						</Row>
					</Container>
				</Col>
			);
		});

		let goBack;
		this.state.posts.map((ne, index) => {
			var idcat = ne.categories.map((categories) => categories.id);
			if (global.notWantedCategoriesMulti.some((r) => idcat.includes(r))) {
				let intersection = global.notWantedCategoriesMulti.filter((x) =>
					idcat.includes(x)
				);
				if (intersection.length !== idcat.length) {
					goBack = (
						<p>
							<Link to="/Divulgación/Multimedia" className="goBacklink">
								<FontAwesomeIcon icon={Icons.faArrowLeft} size="1x" /> Volver a
								Noticias
							</Link>
						</p>
					);
					return null;
				} else if (intersection.includes("7")) {
					goBack = (
						<p>
							<Link to="/recursos/practica-sociologica" className="goBacklink">
								<FontAwesomeIcon icon={Icons.faArrowLeft} size="1x" /> Volver a
								Noticias
							</Link>
						</p>
					);
					return null;
				} else {
					goBack = (
						<p>
							<Link to="/Divulgación/Multimedia" className="goBacklink">
								<FontAwesomeIcon icon={Icons.faArrowLeft} size="1x" /> Volver a
								Noticias
							</Link>
						</p>
					);
					return null;
				}
			} else {
				goBack = (
					<p>
						<Link to="/Divulgación/Multimedia" className="goBacklink">
							<FontAwesomeIcon icon={Icons.faArrowLeft} size="1x" /> Volver a
							Noticias
						</Link>
					</p>
				);
				return null;
			}
		});

		const MetaTagsSeo = posts.map((post) => {
			console.log(post)
			return (
				<SEO
					title={!post.meta_title ? post.title : post.meta_title}
					description={post.meta_description}
					cover_image={post.cover_image}
					key={"SEO" + post.id}
					url={window.location.href}
				></SEO>
			);
		});

		return (
			<section>
				{MetaTagsSeo}
				{title}
				<hr className="whiteSpace"></hr>
				<Container>
					<Row>
						<Col sm={12}>{goBack}</Col>
					</Row>
					<Row className="lastMinuteNews">
						<Col className="sidebar" lg={3} md={3} sm={12}>
							{editThisPage}
							<CategoriesMultimedia />
							<Newsletter />
							<div className="sidebarVideo">{video}</div>
						</Col>
						<Col lg={9} md={9} sm={12}>
							{notice}
						</Col>
					</Row>
				</Container>
			</section>
		);
	}
}

export default MultimediaNotice;
